import { useEffect } from 'react';
import { useThemeStore } from '@/store/themeStore';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const { theme, themeColor, applyCurrentTheme } = useThemeStore();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const root = window.document.documentElement;

    root.classList.remove('light', 'dark');
    root.classList.add(theme);

    // Apply the theme colors
    applyCurrentTheme();
  }, [theme, themeColor, applyCurrentTheme]);

  return <>{children}</>;
}